module.exports = __webpack_public_path__ + "static/media/ReviewNextStepIcon.3faace9b.svg";